import { cx } from '@twind/core';
import { ModuleItem } from 'app/services/helpCenter';
import { useTranslation } from 'react-i18next';

interface PillProps {
  pill: ModuleItem;
  onClick: () => void;
  pillIndex: number;
}

interface TailorSearchPillsProps {
  pills: ModuleItem[];
  onPillClick?: (pill: ModuleItem) => void;
  className?: string;
}

const Pill = ({ pill, onClick, pillIndex }: PillProps) => {
  return (
    <button
      onClick={onClick}
      aria-label={`${pill.pill_text}${pill.icon ? ', has icon' : ''}`}
      aria-describedby={pill.description ? `pill-description-${pillIndex}` : undefined}
      className="ostro-tailor-pill flex items-center gap-2 px-3 py-2 bg-white rounded-lg text-sm leading-none border border-pills-borderColor hover:border-pills-hoverBorderColor focus:border-pills-hoverBorderColor focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
    >
      {pill.icon && (
        <img
          src={pill.icon}
          alt=""
          className="w-[14px] h-[14px]"
          role="presentation"
        />
      )}
      <span>{pill.pill_text}</span>
      {pill.description && (
        <span
          id={`pill-description-${pillIndex}`}
          className="sr-only"
        >
          {pill.description}
        </span>
      )}
    </button>
  );
};

export default function TailorSearchPills({ pills, onPillClick, className }: TailorSearchPillsProps) {
  const { t } = useTranslation();
  const handlePillClick = (pill: ModuleItem) => {
    if (onPillClick) {
      onPillClick(pill);
    }
  };

  return (
    <div
      id="ostro-tailor-pills-container"
      role="group"
      aria-label={t('aria_labels.pills_aria_label')}
      className={cx('~(flex flex-wrap gap-2 pt-4)', className)}
      tabIndex={0}
    >
      {pills.map((pill, index) => (
        <Pill
          key={`${pill.pill_text}-${index}`}
          pill={pill}
          onClick={() => handlePillClick(pill)}
          pillIndex={index}
        />
      ))}
    </div>
  );
}
